import React, { Component, PropTypes } from 'react';
import CategoryIcon from 'components/CategoryIcon';
import ShallowCompare from 'react-addons-shallow-compare';

import './SelectedCategory.scss';

class SelectedCategory extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        return ShallowCompare(this, nextProps, nextState);
    }

    render() {
        return (
            <div className="SelectedCategory">
                <div className="SelectedCategory-image">
                    <div className="SelectedCategory-icon">
                        <CategoryIcon category={this.props.category.name}/>
                    </div>
                </div>
                <div className="SelectedCategory-description">
                    <div className="SelectedCategory-title">
                        Категория перевозки
                    </div>
                    <div className="SelectedCategory-name">
                        {this.props.category.title}
                    </div>
                </div>
            </div>
        );
    }

}

export default SelectedCategory;



// WEBPACK FOOTER //
// ./client/components/SelectedCategory/SelectedCategory.js